import { render, staticRenderFns } from "./HowAreYouUsingKolibri.vue?vue&type=template&id=68ba4ffc"
import script from "./HowAreYouUsingKolibri.vue?vue&type=script&lang=js"
export * from "./HowAreYouUsingKolibri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports